import { Link } from 'react-router-dom';

const linkClass =
    'text-sm text-gray-600 transition hover:text-gray-900 dark:text-gray-400 dark:hover:text-white';

const headingClass =
    'text-xs font-semibold uppercase tracking-wider text-gray-900 dark:text-white';

function FooterLogo() {
    return (
        <svg
            className="h-9 w-auto"
            viewBox="0 0 375 375"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g fill="#000000" fillOpacity="1">
                <g transform="translate(35.850083, 337.651426)">
                    <path d="M88.921875 0H35.953125V-276.609375H98.578125L209.640625-98.390625L214.546875-99.140625V-276.609375H267.15625V0H211.15625L93.65625-190.34375L88.921875-189.578125Z" />
                </g>
            </g>
            <g fill="#E4080A" fillOpacity="1">
                <g transform="translate(61.960085, 337.651426)">
                    <path d="M60.734375 0H4.734375L86.65625-142.28125L8.703125-276.609375H66.78125L124.109375-177.46875H128.84375L187.125-276.609375H242.359375L164.421875-142.28125L246.34375 0H188.4375L126.953125-106.703125H122.21875Z" />
                </g>
            </g>
        </svg>
    );
}

export default function Footer({ embedded = false }) {
    const year = new Date().getFullYear();

    return (
        <footer
            id="site-footer"
            className={`bg-white dark:bg-gray-900 ${embedded ? '' : 'mt-auto'}`}
        >
            <div
                className={`mx-auto max-w-screen-xl px-6 sm:px-8 lg:px-12 ${
                    embedded ? 'py-10 md:py-12' : 'py-14 md:py-16'
                }`}
            >
                <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8">
                    <div className="lg:col-span-4">
                        <Link
                            to="/"
                            className="inline-flex rounded bg-white px-2.5 py-1.5 transition hover:opacity-90"
                        >
                            <span className="sr-only">NexITus home</span>
                            <FooterLogo />
                        </Link>

                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-gray-500 dark:text-gray-400">
                            Ottawa-based IT partner for web, mobile, design, and infrastructure.
                            We help Canadian businesses build, scale, and stay secure.
                        </p>

                        <div className="mt-6">
                            <a
                                href="https://instagram.com/nexitus.ca"
                                target="_blank"
                                rel="noreferrer"
                                className="text-gray-700 transition hover:text-[#E4080A] dark:text-white dark:hover:text-[#E4080A]"
                            >
                                <span className="sr-only">Instagram</span>
                                <svg className="size-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        fillRule="evenodd"
                                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-2 lg:col-start-6">
                        <h3 className={headingClass}>Services</h3>
                        <ul className="mt-4 space-y-2.5">
                            <li>
                                <Link to="/services/web-design" className={linkClass}>
                                    Web Design & Development
                                </Link>
                            </li>
                            <li>
                                <Link to="/services/mobile" className={linkClass}>
                                    iOS & Android Apps
                                </Link>
                            </li>
                            <li>
                                <Link to="/services/IT" className={linkClass}>
                                    IT Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className={linkClass}>
                                    All Services
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <h3 className={headingClass}>Company</h3>
                        <ul className="mt-4 space-y-2.5">
                            <li>
                                <Link to="/about" className={linkClass}>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className={linkClass}>
                                    What We Do
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className={linkClass}>
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <h3 className={headingClass}>Get in Touch</h3>
                        <ul className="mt-4 space-y-3">
                            <li>
                                <a
                                    href="mailto:info@nexitus.ca"
                                    className="group inline-flex items-start gap-2.5 text-sm text-gray-600 transition hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
                                >
                                    <svg
                                        className="mt-0.5 size-4 shrink-0 text-[#E4080A]"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        aria-hidden="true"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                                        />
                                    </svg>
                                    info@nexitus.ca
                                </a>
                            </li>
                            <li className="inline-flex items-start gap-2.5 text-sm text-gray-600 dark:text-gray-400">
                                <svg
                                    className="mt-0.5 size-4 shrink-0 text-[#E4080A]"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    aria-hidden="true"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                                    />
                                </svg>
                                Ottawa &amp; surrounding area, ON
                            </li>
                        </ul>

                        <Link
                            to="/contact"
                            className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#E4080A] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#c00709]"
                        >
                            Start a project
                            <span aria-hidden="true">&rarr;</span>
                        </Link>
                    </div>
                </div>

                <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-gray-100 pt-8 dark:border-gray-800 sm:flex-row">
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                        &copy; {year} NexITus. All rights reserved.
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-500 dark:text-gray-400">
                        <Link to="/contact" className="transition hover:text-gray-700 dark:hover:text-white">
                            Privacy Policy
                        </Link>
                        <Link to="/contact" className="transition hover:text-gray-700 dark:hover:text-white">
                            Terms of Service
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
